import React from 'react'
import PropTypes from 'prop-types'

import FacebookAdPreviewContainer from '../reusablePreviewComponents/FacebookAdPreviewContainer'
import FacebookAdPreviewHeader from '../reusablePreviewComponents/FacebookAdPreviewHeader'
import FacebookCarousel from './FacebookCarousel'

const FacebookCarouselAdPreview = ({ viewAdOnFacebook, formikValues, elementInProgress, isSoundMuted }) => {
  return (
    <FacebookAdPreviewContainer>
      <FacebookAdPreviewHeader elementInProgress={elementInProgress} formikValues={formikValues} />
      <FacebookCarousel
        viewAdOnFacebook={viewAdOnFacebook}
        formikValues={formikValues}
        elementInProgress={elementInProgress}
        isSoundMuted={isSoundMuted}
      />
    </FacebookAdPreviewContainer>
  )
}

FacebookCarouselAdPreview.propTypes = {
  viewAdOnFacebook: PropTypes.string,
  formikValues: PropTypes.object,
  elementInProgress: PropTypes.string,
  isSoundMuted: PropTypes.bool
}

export default FacebookCarouselAdPreview
